export const Applications = {
  tools: "Herramientas",
  adminTools: "Herramientas de administrador",
  deleteSelectedTools: "¿Eliminar herramientas seleccionadas?",
  deleteToolsDescription:
    "Las herramientas se desvincularán de la aplicación. Para volver a vincularlas se deben agregar manualmente.",
  addTools: "Agregar herramienta(s)",
  addSelection: "Agregar seleccionadas",
  deleteSelection: "Eliminar seleccionadas",
  assetTypes: "Tipos de asset",
  myToolkits: "Mis aplicaciones",
  keywords: "Palabras clave",
  selectOrAddAKeyword: "Agrega o selecciona una palabra clave",
  pleaseSelectAToolkit: "Por favor, seleccione una aplicación.",
  setAsDefault: "Fijar como predeterminado",
  removeDefault: "Quitar valor predeterminado",
};
